import {createReducer} from "./index";
import * as R from 'ramda';
import {API_GET_COMPANY_EMPLOYEES_RESULTS, API_GET_COMPANY_EMPLOYEES_START_CLEAR} from "../actions/companies";

const employeesInitial = {
};

const employeesReducer = createReducer(employeesInitial,
  {
    // 'ACTION_NAME': function (state, action) -> new_state
    [API_GET_COMPANY_EMPLOYEES_START_CLEAR]: (state, action) => ({}),
    [API_GET_COMPANY_EMPLOYEES_RESULTS]: (state, action) => {
      let newState = state;
      action.payload.forEach(employee => newState = R.over(R.lensPath([employee.id]), () => employee)(newState));
      return newState;
    },
  }
);

export default employeesReducer;


// WEBPACK FOOTER //
// ./src/reducers/employees.js